import { modalCloseButton } from 'assets/jss/material-dashboard-pro-react';
import cx from 'classnames';
import React from 'react';

import { ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  modalCloseButton,
  title: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '28px',
    lineHeight: '42px',
    color: theme.palette.grayScale11.main,

    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
      lineHeight: '32px',
    },
  },
  titleSmall: {
    fontSize: '24px',
    lineHeight: '32px',
  },
  line: {
    margin: '13px auto 15px',
    width: '100%',
    maxWidth: '163px',
    border: '1px solid rgba(0, 0, 0, 0.44)',
  },
}));

const SimpleModalHeader = ({ onClose, title, small = false }) => {
  const classes = useStyles();

  return (
    <>
      <ButtonBase
        className={classes.modalCloseButton}
        aria-label="Close"
        onClick={onClose}
      >
        <CloseIcon />
      </ButtonBase>

      <div className={cx(classes.title, small && classes.titleSmall)}>{title}</div>
      <div className={classes.line} />
    </>
  );
};

export default SimpleModalHeader;
